// extracted by mini-css-extract-plugin
module.exports = {"container":"_2HGiGC7eAAGyEgL4FTtwb7","icon":"_2SvKc6Ik17xxcpMPllOm0B"};